export default "__VITE_ASSET__5xL6tV4q__"